import MarketingLeadApi from '../../functions/api/booking/MarketingLeadApi';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import TableUtils from '../../functions/TableUtils';
import {
  Button,
  Card,
  Space,
  Table,
  DatePicker,
  Modal,
  Typography,
} from 'antd';
import { columnTitles, TABLE } from './columns';
import isBetween from 'dayjs/plugin/isBetween';
import { withRouter } from 'react-router-dom';
import { keyBy, merge, values } from 'lodash';
import MyUtil from '../../functions/MyUtil';
import React, { Component } from 'react';
import dayjs from 'dayjs';

dayjs.extend(isBetween);
dayjs.extend(localizedFormat);

const { RangePicker } = DatePicker;
const { Paragraph } = Typography;

class ListMarketingLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listMarketingLead: [],
      currentTotal: 0,
      currentDataSource: [],
      selectedRecord: null,
      filteredInfo: TableUtils.getFilterFromUrl(),
    };
  }

  async componentDidMount() {
    await this.loadMarketingLead();
  }

  async loadMarketingLead() {
    const listMarketingLead = await MarketingLeadApi.index();

    this.setState({
      listMarketingLead,
      currentTotal: listMarketingLead.length,
      currentDataSource: listMarketingLead,
    });
  }

  handleInsertButtonClick = () => {
    this.props.history.push('/marketing-lead/add-marketing-lead');
  };

  formatDate = (dateValue) => {
    if (dateValue === null || dateValue === undefined) {
      return null;
    }
    return (
      <>
        {dayjs(dateValue).format('HH:mm')}
        <br />
        {dayjs(dateValue).format('D/M/YYYY')}
      </>
    );
  };

  renderCustomerInfo = (cell, row) => {
    return (
      <React.Fragment>
        <div className="mb-2">
          <strong>{row.name}</strong>
        </div>
        <div>{row.phone}</div>
        <div>{row.email}</div>
      </React.Fragment>
    );
  };

  renderAddress = (cell, row) => {
    let address = '';
    if (row.district_name) {
      address = `${row.district_name}, `;
    }

    return (address += row.city_name);
  };

  getColumnDateRangeFilter = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <RangePicker
          onChange={(selected) => {
            setSelectedKeys([selected]);
            confirm();
          }}
          autoFocus
          format="ll"
        />
      ),
      onFilter: (value, record) => {
        if (!value) {
          return true;
        }

        let [start, end] = value;

        if (!start || !end) {
          return true;
        }

        const recordDateValue = dayjs(record[dataIndex]);
        if (!recordDateValue.isValid()) {
          return false;
        }
        return recordDateValue.isBetween(start, end, 'day', '[]');
      },
    };
  };

  getColumnConfig = (filteredInfo) => {
    const columnConfigs = [
      {
        dataIndex: 'name',
        key: 'name',
        render: this.renderCustomerInfo,
        fixed: 'left',
        filteredValue: filteredInfo.name || null,
        ...TableUtils.getColumnSearchProps('name'),
      },
      {
        dataIndex: 'source',
        key: 'source',
        filteredValue: filteredInfo.source || null,
        ...TableUtils.getColumnDropDownFilter(
          this.state.listMarketingLead,
          'source'
        ),
      },
      {
        dataIndex: 'city_name',
        key: 'city_name',
        render: this.renderAddress,
        filteredValue: filteredInfo.city_name || null,
        ...TableUtils.getColumnSearchProps('city_name'),
      },
      {
        dataIndex: 'vhc_type_name',
        key: 'vhc_type_name',
        filteredValue: filteredInfo.vhc_type_name || null,
        ...TableUtils.getColumnDropDownFilter(
          this.state.listMarketingLead,
          'vhc_type_name'
        ),
      },
      {
        dataIndex: 'rental_date',
        key: 'rental_date',
        render: this.formatDate,
        filteredValue: filteredInfo.rental_date || null,
        ...this.getColumnDateRangeFilter('rental_date'),
      },
      {
        dataIndex: 'return_date',
        key: 'return_date',
        render: this.formatDate,
        filteredValue: filteredInfo.return_date || null,
        ...this.getColumnDateRangeFilter('return_date'),
      },
      {
        dataIndex: 'vhc_name',
        key: 'vhc_name',
      },
      {
        dataIndex: 'renting_purpose',
        key: 'renting_purpose',
      },
      {
        dataIndex: 'status',
        key: 'status',
        filteredValue: filteredInfo.status || null,
        ...TableUtils.getColumnDropDownFilter(
          this.state.listMarketingLead,
          'status'
        ),
      },
      {
        dataIndex: 'failure_reason',
        key: 'failure_reason',
        filteredValue: filteredInfo.failure_reason || null,
        ...TableUtils.getColumnSearchProps('failure_reason'),
      },
      {
        title: null,
        key: 'delete',
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <Button
                onClick={() => {
                  this.setState({ selectedRecord: record });
                }}
                size="small"
                className="pull-right"
              >
                <i className="fas fa-clipboard-list" />
              </Button>
              <Button
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/marketing-lead/edit-marketing-lead/${record.id}`
                  )
                }
              >
                <i className="fas fa-edit" />
              </Button>
            </Space>
          );
        },
      },
    ];

    const titles = columnTitles.filter((t) => t.hideOn !== TABLE.BACKEND);
    // merge titles with configs
    const mergeKey = 'dataIndex';

    return values(
      merge(keyBy(titles, mergeKey), keyBy(columnConfigs, mergeKey))
    );
  };

  tableSourceDidChange = (
    pagination,
    filters,
    sorter,
    { currentDataSource }
  ) => {
    TableUtils.pushFilterToUrl(filters);
    this.setState({
      currentTotal: currentDataSource.length,
      currentDataSource: currentDataSource,
      filteredInfo: filters,
    });
  };

  render() {
    const {
      listMarketingLead,
      currentTotal,
      filteredInfo,
      selectedRecord,
    } = this.state;
    const columns = this.getColumnConfig(filteredInfo);

    return (
      <>
        <h1>Marketing lead</h1>
        <Card className="mb-2" size="small">
          <Space>
            {MyUtil.hasPermission('/marketing-lead', 'add') && (
              <Button onClick={this.handleInsertButtonClick} type="primary">
                Thêm
              </Button>
            )}
          </Space>
        </Card>
        <Modal
          title="Ghi chú"
          visible={!!selectedRecord}
          onCancel={() => this.setState({ selectedRecord: null })}
          footer={
            <Button
              type="primary"
              onClick={() => this.setState({ selectedRecord: null })}
            >
              OK
            </Button>
          }
        >
          {selectedRecord && (
            <>
              {selectedRecord.renting_purpose && (
                <Paragraph className="mt-4">
                  <strong>Mục đích</strong>
                  <pre>{selectedRecord.renting_purpose}</pre>
                </Paragraph>
              )}
              {selectedRecord.schedule && (
                <Paragraph>
                  <strong>Lịch trình</strong>
                  <pre>{selectedRecord.schedule}</pre>
                </Paragraph>
              )}
              {selectedRecord.note && (
                <Paragraph>
                  <strong>Ghi chú</strong>
                  <pre>{selectedRecord.note}</pre>
                </Paragraph>
              )}
              {selectedRecord.call_note && (
                <Paragraph className="mt-4">
                  <strong>Ghi chú liên lạc</strong>
                  <pre>{selectedRecord.call_note}</pre>
                </Paragraph>
              )}
            </>
          )}
        </Modal>
        <Table
          rowKey="id"
          size="small"
          columns={columns}
          dataSource={listMarketingLead}
          scroll={{ x: 'max-content' }}
          onChange={this.tableSourceDidChange}
          title={() => `Tổng số: ${currentTotal}`}
        />
      </>
    );
  }
}

export default withRouter(ListMarketingLead);
